import store, { sessionExpiredAction, accountLockedAction, systemMaintainAction } from '@redux';
import { localStorage } from '@utils';
import {
  saveToken,
  saveUser,
} from '@redux/auth/authSlice';
import {
  setAppStatus,
  saveSettings,
  saveUserPreferedLanguage,
  setHasWithdrawAccount,
} from '@redux/app/appSlice';
import { api, Status } from '@api';
import { changeLocale } from '@i18n';

const getUserPayments = () => {
  api
    .getUserPayments()
    .then(({ user_payments }) => {
      store.dispatch(setHasWithdrawAccount(user_payments.length > 0));
    })
    .catch(() => { });
};

const getSettings = () => {
  api
    .getSettings()
    .then(({ setting }) => {
      // save settings to redux
      store.dispatch(saveSettings(setting));

      const userPreferedLanguage = localStorage.getUserPreferedLanguage();
      // set system default lang if not have already
      if (!userPreferedLanguage) {
        let sys_defined_lang = setting.lang;
        // save lang to localstorage
        localStorage.setUserPreferedLanguage(sys_defined_lang);
        // save lang to redux
        store.dispatch(saveUserPreferedLanguage(sys_defined_lang));
        // update lang in request obj
        api.setUserPreferedLanguage(sys_defined_lang);
        // set i18n lang
        changeLocale(sys_defined_lang);
      }

    })
    .catch((errorMsg) => {
      console.error(errorMsg);
    });
}

const initializeApp = () => {
  try {
    setAppStatus(Status.LOADING);

    // setup app language
    const lang = localStorage.getUserPreferedLanguage();

    if (lang) {
      // save lang to redux
      store.dispatch(saveUserPreferedLanguage(lang));
    }

    // init api request
    api.init({
      lang,
      sessionExpiredAction,
      accountLockedAction,
      systemMaintainAction,
    });

    // get app settings from server
    getSettings();

    setAppStatus(Status.SUCCESS);

  } catch (error) {
    setAppStatus(Status.ERROR);
  }
};

const checkAuthorization = () => {
  const token = localStorage.getToken();
  const user = localStorage.getUser();

  if (token) {
    // save token and user to redux
    store.dispatch(saveToken(token));
    store.dispatch(saveUser(user));

    // set token to request obj
    api.setSessionToken(token);
    getUserPayments();
  }
};

const boot = () =>
  new Promise(() => {
    initializeApp();
    checkAuthorization();
  });

export default boot;
